module.exports = __webpack_public_path__ + "img/stock3.6d661ad3.png";